import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { Modal } from 'react-responsive-modal';
import { styled } from '@mui/material/styles';
import { LuMapPin } from 'react-icons/lu';

const StyledDiv = styled('div')(() => ({
  '& > div': {
    fontSize: '13px',
    color: '#333',
    textAlign: 'center',
    width: '100%',
    lineHeight: 1,
    marginBottom: '4px',
    '& > span': {
      fontWeight: 'bold',
    },
  },
  '& button': {
    backgroundColor: '#4285f4',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    marginTop: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    width: 'max-content',
    '&:hover': {
      backgroundColor: '#3367d6',
    },
  },
}));

const MapContainer = styled('div')({
  width: '100%',
  height: '400px',
  border: '1px solid #ddd',
  borderRadius: '4px',
  overflow: 'hidden',
});

const MapModal = ({ acts, showOnlyMap }) => {
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const hasValidCoordinates = acts?.latitude && acts?.longitude;

  return (
    <StyledDiv>
      {!showOnlyMap ? (
        <>
          <div className="text-nowrap">
            Lat : <span>{acts?.latitude || 'N/A'}</span>
          </div>
          <div className="text-nowrap">
            Long : <span>{acts?.longitude || 'N/A'}</span>
          </div>
          <div className="text-nowrap">
            <LuMapPin color="#3367d6" fontSize="16px" />{' '}
            <span>{acts?.city || 'N/A'}</span>
          </div>
        </>
      ) : null}

      <div style={{ margin: 'auto' }}>
        <Button onClick={onOpenModal}>View on Map</Button>
      </div>

      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{ modal: 'custom-modal' }}
      >
        <div style={{ padding: '18px', maxWidth: '100%' }}>
          <h4
            style={{ marginTop: '-20px', marginBottom: '16px' }}
            className="d-flex align-items-center text-nowrap"
          >
            {acts.city}
            <LuMapPin color="#3367d6" style={{ marginLeft: '6px' }} />
          </h4>
          {hasValidCoordinates ? (
            <MapContainer>
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                scrolling="no"
                marginHeight={0}
                marginWidth={0}
                src={`https://www.openstreetmap.org/export/embed.html?bbox=${acts.longitude - 0.01},${acts.latitude - 0.01},${acts.longitude + 0.01},${acts.latitude + 0.01}&layer=mapnik&marker=${acts.latitude},${acts.longitude}`}
                style={{ border: 0 }}
              />
            </MapContainer>
          ) : (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              No valid coordinates available to display map
            </div>
          )}
        </div>
      </Modal>
    </StyledDiv>
  );
};

export default MapModal;
